import React from "react"
import Box from "../../lib/ui/ui-box"
import Text from "../text"
import { injectIntl, FormattedMessage } from "react-intl"
import { connect } from "react-redux"
import { compose } from "recompose"

const Step = props => {
    return (
        <Box onSubmit={props.handleSubmit}>
            <Box flexDirection="column" w={["90%", "90%", "501px"]}>
                {/* Title */}
                <Text
                    align="center"
                    fontWeight="700"
                    fontSize={[4]}
                    color="black"
                    fontFamily="Libre Baskerville"
                    mb={[1]}>
                    <FormattedMessage
                        id="renewal.thankYou.title"
                        defaults="Thank you" />
                </Text>
                {/* Description */}
                <Text
                    align="center"
                    fontSize={[2]}
                    fontWeight="400"
                    lineHeight={3}
                    fontFamily="Libre Baskerville"
                    color="black">
                    <FormattedMessage
                        id="renewal.thankYou.description"
                        defaults="Thank you" />
                </Text>
            </Box>
        </Box>

    )
};

export default compose(
    connect(
        null
    ),
    injectIntl
)(Step)




// WEBPACK FOOTER //
// ./src/components/renewal-wizard/step-six.component.js